import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { HiOutlineTrash, HiOutlinePlus, HiOutlineMinus } from 'react-icons/hi';
import { useCurrency } from '../context/CurrencyContext';

const Cart: React.FC = () => {
  const { items, removeItem, updateQuantity, totalPrice } = useCart();
  const { formatPrice } = useCurrency();

  if (items.length === 0) {
    return (
      <div className="cart-page">
        <div className="empty-cart">
          <h2>Your cart is empty</h2>
          <p>Looks like you haven't added any items yet.</p>
          <Link to="/shop" className="btn btn-primary">Continue Shopping</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <h1>Shopping Cart</h1>

      <div className="cart-layout">
        <div className="cart-items">
          {items.map((item, index) => {
            const price = item.product.discount_price
              ? parseFloat(item.product.discount_price)
              : parseFloat(item.product.price);

            return (
              <div key={index} className="cart-item">
                <div className="cart-item-image">
                  {item.product.image ? (
                    <img src={item.product.image} alt={item.product.name} />
                  ) : (
                    <div className="image-placeholder-sm">YIBE</div>
                  )}
                </div>
                <div className="cart-item-details">
                  <Link to={`/product/${item.product.slug}`} className="cart-item-name">
                    {item.product.name}
                  </Link>
                  <p className="cart-item-meta">
                    {item.size && <span>Size: {item.size}</span>}
                    {item.color && <span>Color: {item.color}</span>}
                  </p>
                  <p className="cart-item-price">{formatPrice(price)}</p>
                </div>
                <div className="cart-item-quantity">
                  <button onClick={() => updateQuantity(index, item.quantity - 1)}>
                    <HiOutlineMinus size={16} />
                  </button>
                  <span>{item.quantity}</span>
                  <button onClick={() => updateQuantity(index, item.quantity + 1)}>
                    <HiOutlinePlus size={16} />
                  </button>
                </div>
                <div className="cart-item-total">
                  {formatPrice(price * item.quantity)}
                </div>
                <button className="cart-item-remove" onClick={() => removeItem(index)}>
                  <HiOutlineTrash size={18} />
                </button>
              </div>
            );
          })}
        </div>

        <div className="cart-summary">
          <h3>Order Summary</h3>
          <div className="summary-row">
            <span>Subtotal</span>
            <span>{formatPrice(totalPrice)}</span>
          </div>
          <div className="summary-row">
            <span>Shipping</span>
            <span>{totalPrice >= 100 ? 'Free' : formatPrice(9.99)}</span>
          </div>
          <div className="summary-row total">
            <span>Total</span>
            <span>{formatPrice(totalPrice >= 100 ? totalPrice : totalPrice + 9.99)}</span>
          </div>
          <Link to="/checkout" className="btn btn-primary btn-lg btn-full">
            Proceed to Checkout
          </Link>
          <Link to="/shop" className="btn btn-outline btn-full">
            Continue Shopping
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Cart;
